
import React from 'react';
import ShopPage from '../../shop';

export default ({ shopId, abondoneShop }) => <ShopPage abondoneShop = {abondoneShop} match={{ params: { shopId } }} inModal = {true} location = {{ search: ''}} />